import React from 'react'

import Navbar from './components/navbar/Navbar';
import Main from './components/Main/Main';
import Social from './components/sociallinks/Social';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Experience from './components/experience/Experience';
import Certificate from './components/certificate/Certificate';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Projects from './components/project/Projects';




function App() {

   
  
  
  return (
    <>
    
 <Navbar />
 <Main/>
 <Social/>
 <About/>
 <Skills/>
 <Experience/>
 <Certificate/>
 <Projects/>
 <Contact/>
 <Footer/>



    </>
  )
}

export default App
